var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"height":_vm.height,"show-arrows":_vm.images && _vm.images.length > 1,"hide-delimiters":""}},_vm._l((_vm.images),function(image,i){return _c('v-carousel-item',{key:i,attrs:{"src":_vm._f("image")(image)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }